import { render, staticRenderFns } from "./task-progress.vue?vue&type=template&id=428a0794&scoped=true&"
import script from "./task-progress.vue?vue&type=script&lang=js&"
export * from "./task-progress.vue?vue&type=script&lang=js&"
import style0 from "./task-progress.vue?vue&type=style&index=0&id=428a0794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a0794",
  null
  
)

export default component.exports